import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { types, actions } from './reducer';
import { extractError } from '@iso/lib//helpers/api';
import GroupService from '@iso/services/AccountService/GroupService';

function* viewGroup({ id }) {
    try {
        const response = yield call(GroupService.getOne, id);
        yield put(actions.viewGroupSucceeded(response.data));
    } catch (error) {
        yield put(actions.viewGroupFailed(extractError(error)));
    }
}

function* watchViewGroup() {
    yield takeEvery(
        types.REQUEST_VIEW_GROUP,
        viewGroup,
    );
}

function* viewSaga() {
    yield all([
        fork(watchViewGroup),
    ]);
}

export default viewSaga;
